import React from 'react';
import CartItem from './CartItem';

const CartProducts = (props) => {
    const cart = props.cart

    return ( 
        <div>
            <div className="card card-body border-0">
                {
                    cart.map(product =>  <CartItem key={product._id} product={product} refresh={props.refresh} />)
                }
            </div>
        </div>
     );
}
 
export default CartProducts;